// extracted by mini-css-extract-plugin
module.exports = {"content":"ResourceListPage_content__28yMS","tab":"ResourceListPage_tab__1p_Uf","active":"ResourceListPage_active__1lL-r"};